import React, { useState } from "react";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";

import { RNHEstablecimientoUpd } from "services/services-mia/programa-salud/estructuras/RNHEstablecimientoUpd";

import { round6 } from "components/utils/mapa/useUbicacion";

import EstablecimientoFormulario from "pages/programa-salud/estructuras/establecimientos/EstablecimientoFormulario";
import { permisosDesdeRow } from "pages/programa-salud/estructuras/components/PermisosDeReparticion";

const TIPO = "C";

export default function UpdateModal({ row, updateList, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);

    /**
     * Los valores salen de la FILA, no de un Get propio.
     *
     * RNHEstablecimientoGet ya devuelve todo lo que este formulario necesita, asi que
     * pedir el registro de nuevo al abrir el modal era una request sin dato nuevo.
     *
     * Y hay una razon ademas de la request: la `version` de la fila es la de cuando se
     * cargo la lista. Si otro usuario modifico este registro mientras tanto, guardar se
     * rechaza —que es para lo que existe la version—. Con el re-Get se traia una version
     * fresca y el guardado pisaba el cambio ajeno sin avisar.
     *
     * Se arma en el render y no en un state: Formik lee initialValues una sola vez, al
     * montarse, y el objeto ya esta completo desde el primer render. Eso ademas es lo que
     * necesita el mapa, que lee lat y lng al montarse para saber donde nace el pin.
     */
    const valores = {
        id: row.id,
        version: row.version,
        cod: row.cod ?? "",
        name: row.name ?? "",
        calle: row.calle ?? "",
        numero: row.numero ?? "",
        cpa: row.cpa ?? "",
        localidadId: row.localidadId ?? "",
        lat: row.lat ? round6(row.lat) : "",
        lng: row.lng ? round6(row.lng) : "",
        ...permisosDesdeRow(row),
    };

    const handleUpdateCap = async (values) => {
        setInRequest(true);

        // id y version no los edita el formulario, se arrastran del detalle.
        const response = await RNHEstablecimientoUpd(credentials, {
            ...values,
            type: TIPO,
            id: valores.id,
            version: valores.version,
        });

        if (response.ok) {
            setSnackBarInfo({
                message: "CAPS modificado correctamente",
                severity: "success",
                open: true,
            });
            updateList();
            closeModal();
        }

        setInRequest(false);
    };

    return (
        <EstablecimientoFormulario
            initialValues={valores}
            onSubmit={handleUpdateCap}
            botonTexto="Guardar cambios"
            inRequest={inRequest}
            closeModal={closeModal}
            conPermisos
        />
    );
}
